/* Product assistant (snippets/fortisana-chat.liquid).
   Talks to the fortisana-chat Worker: POST /session once per browser
   session (with a Turnstile token when a site key is set), then POST /chat.
   The conversation is kept in sessionStorage so it survives page views. */
(function () {
  'use strict';

  var root = document.querySelector('[data-fx-chat]');
  if (!root) return;

  var endpoint = (root.getAttribute('data-endpoint') || '').replace(/\/+$/, '');
  var siteKey = root.getAttribute('data-turnstile') || '';
  var fallbackText = root.getAttribute('data-fallback') || 'Gerade klappt es nicht. Schreib uns gern per E-Mail oder WhatsApp.';
  var contactEmail = (root.getAttribute('data-email') || '').trim();
  var contactWhatsapp = (root.getAttribute('data-whatsapp') || '').trim();
  var launch = root.querySelector('[data-fx-chat-open]');
  var panel = root.querySelector('.fx-chat__panel');
  var scrim = root.querySelector('[data-fx-chat-scrim]');
  var log = root.querySelector('[data-fx-chat-log]');
  var chips = root.querySelector('[data-fx-chat-chips]');
  var form = root.querySelector('[data-fx-chat-form]');
  var input = root.querySelector('[data-fx-chat-input]');
  var send = root.querySelector('[data-fx-chat-send]');
  var tsBox = root.querySelector('[data-fx-chat-ts]');
  var closeBtn = root.querySelector('[data-fx-chat-close]');
  var html = document.documentElement;
  var phone = window.matchMedia('(max-width: 749px)');

  var TOKEN_KEY = 'fxChatToken';
  var LOG_KEY = 'fxChatLog';
  var busy = false;
  var isOpen = false;
  var closeTimer = null;

  /* ---------- storage (fails quietly in private modes) ---------- */
  function load(key) {
    try {
      return JSON.parse(sessionStorage.getItem(key) || 'null');
    } catch (e) {
      return null;
    }
  }
  function save(key, value) {
    try {
      if (value === null) sessionStorage.removeItem(key);
      else sessionStorage.setItem(key, JSON.stringify(value));
    } catch (e) {}
  }

  function track(name) {
    if (typeof window.gtag === 'function') window.gtag('event', name, { event_category: 'product_assistant' });
  }

  /* ---------- open and close ---------- */
  function placeScrim() {
    root.style.setProperty('--fxc-sy', (window.scrollY || window.pageYOffset || 0) + 'px');
  }

  // a scroll still running when the panel opens (smooth scrolling, a fling)
  // must not leave the backdrop behind
  window.addEventListener(
    'scroll',
    function () {
      if (!scrim.hidden) placeScrim();
    },
    { passive: true }
  );

  function open() {
    if (isOpen) return;
    isOpen = true;
    clearTimeout(closeTimer);
    panel.hidden = false;
    if (phone.matches) {
      // the backdrop is not fixed (see the stylesheet): place it over the
      // visible part of the page
      placeScrim();
      scrim.hidden = false;
    }
    // read layout once so both transitions start from the hidden state
    void scrim.offsetWidth;
    void panel.offsetWidth;
    root.classList.add('is-open');
    launch.setAttribute('aria-expanded', 'true');
    html.classList.add('fx-chat-open');
    if (phone.matches) html.classList.add('fx-chat-lock');
    // desktop: ready to type. Phones: no auto focus, it would hide the blinking
    // cursor without opening the keyboard (iOS ignores focus outside a tap)
    if (!phone.matches) {
      setTimeout(function () {
        input.focus({ preventScroll: true });
      }, 60);
    }
    scrollDown();
    track('fx_chat_open');
  }

  function close() {
    if (!isOpen) return;
    isOpen = false;
    clearKb();
    root.classList.remove('is-open');
    launch.setAttribute('aria-expanded', 'false');
    // the page fades back in and stays locked while the panel slides down
    // (0.4s on phones); then the panel and backdrop leave the layout
    closeTimer = setTimeout(function () {
      panel.hidden = true;
      scrim.hidden = true;
      html.classList.remove('fx-chat-open', 'fx-chat-lock');
    }, 440);
    launch.focus({ preventScroll: true });
  }

  /* ---------- phones: keyboard ----------
     iOS does not shrink the page for the keyboard. While it covers part of the
     screen (visualViewport smaller than the layout), the panel fills exactly
     the visible area, header at the top edge, and the page fades out behind it.
     Safari may also shift the visible area (visualViewport.offsetTop) to reveal
     the field; --fxc-pan undoes that shift instantly so it never shows as a
     jump, while the panel's own move between sheet and keyboard layout eases
     from wherever it is on screen at that moment (morph). */
  var fitFrame = 0;
  var lastH = -1;
  var lastPan = -1;

  function clearKb() {
    root.classList.remove('is-kb');
    html.classList.remove('fx-chat-kb');
    root.style.removeProperty('--fxc-pan');
    root.style.removeProperty('--fxc-vv-h');
    lastH = -1;
    lastPan = -1;
  }

  // apply a layout change, then ease top and height from the panel's current
  // on-screen position to the new one
  function morph(apply) {
    var vv = window.visualViewport;
    var pan = vv ? Math.max(0, vv.offsetTop) : 0;
    var cs = window.getComputedStyle(panel);
    var wasKb = root.classList.contains('is-kb');
    // in keyboard layout the margin already cancels the shift; otherwise the
    // panel shows shifted up by it
    var screenTop = parseFloat(cs.top) - (wasKb ? 0 : pan);
    var h = parseFloat(cs.height);
    panel.style.transition = 'none';
    apply();
    var margin = root.classList.contains('is-kb') ? pan : 0;
    panel.style.top = screenTop + pan - margin + 'px';
    panel.style.height = h + 'px';
    void panel.offsetWidth;
    panel.style.transition = '';
    panel.style.top = '';
    panel.style.height = '';
  }

  function fitToViewport() {
    fitFrame = 0;
    var vv = window.visualViewport;
    var isKb = root.classList.contains('is-kb');
    if (!isOpen || !phone.matches || !vv) {
      if (isKb) clearKb();
      return;
    }
    // innerHeight shrinks with the keyboard on some iOS versions, the layout
    // height does not
    var layoutH = document.documentElement.clientHeight || window.innerHeight;
    var covered = layoutH - vv.height;
    if (covered > 120) {
      var h = Math.round(vv.height);
      var pan = Math.round(Math.max(0, vv.offsetTop));
      if (!isKb || h !== lastH) {
        morph(function () {
          root.style.setProperty('--fxc-pan', pan + 'px');
          root.style.setProperty('--fxc-vv-h', h + 'px');
          root.classList.add('is-kb');
          // iOS ends fixed layers at the keyboard's top edge, so the page
          // itself fades out (it would show through the keyboard otherwise)
          html.classList.add('fx-chat-kb');
        });
        if (!isKb) scrollDown();
      } else if (pan !== lastPan) {
        // only the shift changed: follow it in the same frame
        root.style.setProperty('--fxc-pan', pan + 'px');
      }
      lastH = h;
      lastPan = pan;
    } else if (isKb) {
      morph(clearKb);
    }
  }

  function scheduleFit() {
    if (fitFrame) return;
    fitFrame = window.requestAnimationFrame ? window.requestAnimationFrame(fitToViewport) : setTimeout(fitToViewport, 16);
  }

  if (window.visualViewport) {
    window.visualViewport.addEventListener('resize', scheduleFit);
    window.visualViewport.addEventListener('scroll', scheduleFit);
  }
  window.addEventListener('resize', scheduleFit);

  /* a tap on the field: focus it ourselves while it is moved far up for one
     frame, so iOS sees nothing to reveal and does not slide the whole view up
     with the keyboard (the same trick React Aria uses). The panel then eases
     into the keyboard layout on its own. */
  var touchY = null;
  input.addEventListener(
    'touchstart',
    function (e) {
      touchY = e.touches && e.touches.length === 1 ? e.touches[0].clientY : null;
    },
    { passive: true }
  );
  input.addEventListener('touchend', function (e) {
    var t = e.changedTouches && e.changedTouches[0];
    var moved = touchY === null || !t || Math.abs(t.clientY - touchY) > 10;
    touchY = null;
    if (moved || !phone.matches || input.readOnly || document.activeElement === input) return;
    e.preventDefault();
    input.style.transform = 'translateY(-2000px)';
    input.focus({ preventScroll: true });
    window.requestAnimationFrame(function () {
      input.style.transform = '';
    });
  });

  input.addEventListener('focus', function () {
    fieldActive = true;
    root.classList.add('is-typing');
    // the keyboard animates in; measure again once it has settled
    scheduleFit();
    setTimeout(scheduleFit, 350);
  });
  input.addEventListener('blur', function () {
    fieldActive = false;
    root.classList.remove('is-typing');
    scheduleFit();
    setTimeout(scheduleFit, 350);
  });

  launch.addEventListener('click', open);
  closeBtn.addEventListener('click', close);
  scrim.addEventListener('click', close);
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') close();
  });
  // a tap anywhere outside the panel closes it
  document.addEventListener('pointerdown', function (e) {
    if (!isOpen) return;
    if (panel.contains(e.target) || launch.contains(e.target)) return;
    close();
  });

  /* ---------- rendering ---------- */
  function scrollDown() {
    log.scrollTop = log.scrollHeight;
  }

  // e-mail and WhatsApp buttons under a message the assistant could not answer
  function contactRow() {
    var links = [];
    if (contactEmail) links.push(['E-Mail schreiben', 'mailto:' + contactEmail, 'email']);
    if (/^https:\/\//.test(contactWhatsapp)) links.push(['WhatsApp an Max', contactWhatsapp, 'whatsapp']);
    if (!links.length) return null;
    var row = document.createElement('div');
    row.className = 'fx-chat__contact';
    links.forEach(function (l) {
      var a = document.createElement('a');
      a.className = 'fx-chat__chip';
      a.textContent = l[0];
      a.href = l[1];
      if (l[2] === 'whatsapp') {
        a.target = '_blank';
        a.rel = 'noopener';
      }
      a.addEventListener('click', function () {
        track('fx_chat_contact_' + l[2]);
      });
      row.appendChild(a);
    });
    return row;
  }

  // the suggested questions from the start of the chat, offered again under
  // an off-topic reply; a tap asks the question
  var suggestions = chips
    ? Array.prototype.map.call(chips.querySelectorAll('[data-fx-chat-chip]'), function (b) {
        return b.textContent.trim();
      }).filter(Boolean)
    : [];

  function suggestRow() {
    if (!suggestions.length) return null;
    var row = document.createElement('div');
    row.className = 'fx-chat__chips fx-chat__suggest';
    suggestions.forEach(function (q) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'fx-chat__chip';
      b.textContent = q;
      b.addEventListener('click', function () {
        track('fx_chat_suggestion_retry');
        ask(q);
      });
      row.appendChild(b);
    });
    return row;
  }

  function addMessage(kind, text, contact, suggest) {
    var wrap = document.createElement('div');
    wrap.className = 'fx-chat__msg fx-chat__msg--' + kind;
    var p = document.createElement('p');
    p.style.margin = '0';
    p.textContent = text;
    wrap.appendChild(p);
    var row = contact ? contactRow() : null;
    if (row) wrap.appendChild(row);
    var sug = suggest ? suggestRow() : null;
    if (sug) wrap.appendChild(sug);

    log.appendChild(wrap);
    scrollDown();
    return wrap;
  }

  function typing() {
    var el = document.createElement('div');
    el.className = 'fx-chat__msg fx-chat__msg--bot';
    el.innerHTML = '<span class="fx-chat__typing" aria-label="Antwort wird geschrieben"><span></span><span></span><span></span></span>';
    log.appendChild(el);
    scrollDown();
    return el;
  }

  function remember(kind, text, contact, suggest) {
    var items = load(LOG_KEY) || [];
    var item = { k: kind, t: text };
    if (contact) item.c = 1;
    if (suggest) item.s = 1;
    items.push(item);
    save(LOG_KEY, items.slice(-40));
  }

  function restore() {
    var items = load(LOG_KEY) || [];
    if (!items.length) return;
    if (chips) chips.hidden = true;
    items.forEach(function (m) {
      addMessage(m.k, m.t, !!m.c, !!m.s).style.animation = 'none';
    });
  }

  /* ---------- session ---------- */
  var turnstileReady = null;

  function loadTurnstile() {
    if (turnstileReady) return turnstileReady;
    turnstileReady = new Promise(function (resolve, reject) {
      if (window.turnstile) return resolve(window.turnstile);
      var s = document.createElement('script');
      s.src = 'https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit';
      s.async = true;
      s.onload = function () {
        resolve(window.turnstile);
      };
      s.onerror = function () {
        turnstileReady = null;
        reject(new Error('turnstile'));
      };
      setTimeout(function () {
        if (!window.turnstile) {
          turnstileReady = null;
          reject(new Error('turnstile'));
        }
      }, 10000);
      document.head.appendChild(s);
    });
    return turnstileReady;
  }

  var widgetId = null;

  function clearWidget() {
    if (widgetId !== null && window.turnstile) {
      try {
        window.turnstile.remove(widgetId);
      } catch (e) {}
    }
    widgetId = null;
    tsBox.innerHTML = '';
  }

  function turnstileToken() {
    if (!siteKey) return Promise.resolve('');
    return loadTurnstile().then(function (ts) {
      return new Promise(function (resolve, reject) {
        var done = false;
        // the silent check normally takes a second or two; if it neither answers
        // nor asks for a click, give up instead of leaving the visitor waiting
        var timer = setTimeout(function () {
          fail();
        }, 15000);
        function finish(fn, value) {
          if (done) return;
          done = true;
          clearTimeout(timer);
          fn(value);
          setTimeout(clearWidget, 400);
        }
        function fail() {
          finish(reject, new Error('turnstile'));
        }
        clearWidget();
        var holder = document.createElement('div');
        tsBox.appendChild(holder);
        widgetId = ts.render(holder, {
          sitekey: siteKey,
          appearance: 'interaction-only',
          size: 'flexible',
          language: 'de',
          callback: function (token) {
            finish(resolve, token);
          },
          // a visible check box is waiting for the visitor: no time limit then
          'before-interactive-callback': function () {
            clearTimeout(timer);
            scrollDown();
          },
          'error-callback': fail,
          'timeout-callback': fail,
          'expired-callback': fail,
          'unsupported-callback': fail,
        });
      });
    });
  }

  function getToken(forceNew) {
    var stored = load(TOKEN_KEY);
    if (!forceNew && stored && stored.expires > Date.now() + 30000) return Promise.resolve(stored.token);
    return turnstileToken().then(function (ts) {
      return fetch(endpoint + '/session', {
        method: 'POST',
        headers: { 'content-type': 'application/json' },
        body: JSON.stringify({ turnstile: ts }),
      })
        .then(function (r) {
          return r.json().then(function (d) {
            return { ok: r.ok, data: d };
          });
        })
        .then(function (res) {
          if (!res.ok || !res.data.token) {
            var err = new Error('session');
            err.userMessage = res.data && res.data.message;
            throw err;
          }
          save(TOKEN_KEY, { token: res.data.token, expires: res.data.expires });
          return res.data.token;
        });
    });
  }

  /* ---------- sending ---------- */
  function setBusy(on) {
    busy = on;
    send.disabled = on;
    input.readOnly = on;
  }

  function post(token, text) {
    return fetch(endpoint + '/chat', {
      method: 'POST',
      headers: { 'content-type': 'application/json', authorization: 'Bearer ' + token },
      body: JSON.stringify({ message: text, page: location.pathname }),
    }).then(function (r) {
      return r.json().then(function (d) {
        return { status: r.status, data: d };
      });
    });
  }

  function ask(text) {
    text = (text || '').replace(/\s+/g, ' ').trim();
    if (!text || busy) return;
    if (chips) chips.hidden = true;
    addMessage('user', text);
    remember('user', text);
    input.value = '';
    autosize();
    setBusy(true);
    var dots = typing();
    track('fx_chat_send');

    getToken(false)
      .then(function (token) {
        return post(token, text).then(function (res) {
          // expired or unknown session: start a fresh one and try once more
          if (res.status === 401) {
            save(TOKEN_KEY, null);
            return getToken(true).then(function (t2) {
              return post(t2, text);
            });
          }
          return res;
        });
      })
      .then(function (res) {
        dots.remove();
        if (res.status === 200 && res.data.answer) {
          // no answer from the product info, an error or the daily limit:
          // offer a direct line to the team
          var contact = /^(fallback|error|cap)$/.test(res.data.outcome || '');
          // off-topic: offer the suggested questions instead
          var suggest = res.data.outcome === 'off_topic';
          addMessage('bot', res.data.answer, contact, suggest);
          remember('bot', res.data.answer, contact, suggest);
        } else {
          var note = (res.data && res.data.message) || fallbackText;
          addMessage('note', note, true);
          remember('note', note, true);
        }
      })
      .catch(function (err) {
        dots.remove();
        var note = (err && err.userMessage) || fallbackText;
        addMessage('note', note, true);
        remember('note', note, true);
      })
      .then(function () {
        setBusy(false);
        // phones: no programmatic focus (iOS would not open the keyboard,
        // but the panel would switch to its typing layout)
        if (!phone.matches) input.focus({ preventScroll: true });
      });
  }

  /* ---------- input ---------- */
  function autosize() {
    input.style.height = 'auto';
    input.style.height = Math.min(input.scrollHeight, 120) + 'px';
  }

  input.addEventListener('input', autosize);
  input.addEventListener('keydown', function (e) {
    if (e.key === 'Enter' && !e.shiftKey && !e.isComposing) {
      e.preventDefault();
      ask(input.value);
    }
  });
  form.addEventListener('submit', function (e) {
    e.preventDefault();
    ask(input.value);
  });
  if (chips) {
    chips.addEventListener('click', function (e) {
      var chip = e.target.closest('[data-fx-chat-chip]');
      if (chip) ask(chip.textContent);
    });
  }

  // any link to #frage opens the assistant, like #tum-studie opens the study modal
  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('a[href$="#frage"]');
    if (!a) return;
    e.preventDefault();
    open();
  });

  /* ---------- science page: the launcher docks into the "ask" section ----------
     The launcher stays in its fixed spot until the slot
     (sections/fortisana-science-frag.liquid) scrolls up to it; at that
     moment it is swapped, at the same screen position, for a copy of itself
     placed over the slot in page coordinates, so the browser scrolls it with
     the section from then on: nothing chases a moving target, at any scroll
     speed. The slot plays its ripple on the swap. Scrolled back, it is
     handed back to the fixed spot where the slot passes it. Where the fixed
     spot is off centre (desktop, bottom right), the launcher first glides
     to the centre as the section approaches (0.6s, ease in-out) and back
     when it moves away again. It is re-placed only when the page's layout
     changes (a fold opening above, a resize), never per scroll frame. */
  (function () {
    var dock = document.querySelector('[data-fx-chat-dock]');
    if (!dock) return;
    var docked = false;
    var centred = false;
    var fromBottom = 0; // distance of the free launcher's centre from the viewport bottom
    var ticking = false;
    var cbX = 0;
    var cbY = 0;

    // page coordinates of the slot's centre, from untransformed sizes only
    function place() {
      var r = dock.getBoundingClientRect();
      var left = Math.round((r.left + (window.scrollX || 0) + (r.width - launch.offsetWidth) / 2 - cbX) * 2) / 2;
      var top = Math.round((r.top + (window.scrollY || 0) + (r.height - launch.offsetHeight) / 2 - cbY) * 2) / 2;
      if (launch.style.left !== left + 'px') launch.style.left = left + 'px';
      if (launch.style.top !== top + 'px') launch.style.top = top + 'px';
    }

    // once per docking: where the containing block sits relative to the page
    function calibrate() {
      cbX = 0;
      cbY = 0;
      place();
      var r = dock.getBoundingClientRect();
      var b = launch.getBoundingClientRect();
      cbX = b.left - (r.left + (r.width - b.width) / 2);
      cbY = b.top - (r.top + (r.height - b.height) / 2);
      place();
    }

    // one frame without transitions, so a swap never animates
    function still(fn) {
      root.classList.add('is-still');
      fn();
      void launch.offsetWidth;
      window.requestAnimationFrame(function () {
        root.classList.remove('is-still');
      });
    }

    // the free launcher's centre, without the glide
    function freeCentre() {
      var b = launch.getBoundingClientRect();
      var gx = centred ? parseFloat(root.style.getPropertyValue('--fxc-gx')) || 0 : 0;
      return { x: b.left + b.width / 2 - gx, y: b.top + b.height / 2 };
    }

    function centre(on) {
      if (on === centred) return;
      if (on) {
        var f = freeCentre();
        var r = dock.getBoundingClientRect();
        var gx = r.left + r.width / 2 - f.x;
        if (Math.abs(gx) < 2) return; // already centred (phones)
        root.style.setProperty('--fxc-gx', gx.toFixed(1) + 'px');
      }
      centred = on;
      root.classList.toggle('is-centred', on);
    }

    function landed() {
      dock.classList.remove('is-placed');
      root.classList.remove('is-placed');
      void dock.offsetWidth;
      dock.classList.add('is-placed');
      root.classList.add('is-placed');
    }

    function dockIn(ripple) {
      var b = launch.getBoundingClientRect();
      fromBottom = (window.innerHeight || 800) - (b.top + b.height / 2);
      docked = true;
      still(function () {
        root.classList.add('is-docked');
        dock.style.setProperty('--fxk-w', launch.offsetWidth + 'px');
        dock.style.setProperty('--fxk-h', launch.offsetHeight + 'px');
        calibrate();
      });
      if (ripple) landed();
    }

    function dockOut() {
      docked = false;
      dock.classList.remove('is-placed');
      still(function () {
        root.classList.remove('is-docked', 'is-placed');
        launch.style.left = '';
        launch.style.top = '';
      });
    }

    function check() {
      ticking = false;
      if (isOpen) return;
      var vh = window.innerHeight || 800;
      var r = dock.getBoundingClientRect();
      var c = r.top + r.height / 2;
      if (!docked) {
        centre(c < vh * 1.6 || (centred && c < vh * 1.9));
        var y = launch.getBoundingClientRect();
        y = y.top + y.height / 2;
        if (c <= y) dockIn(c > 0);
      } else if (c > vh - fromBottom) {
        dockOut();
      }
    }

    function onScroll() {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(check);
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', function () {
      if (docked) calibrate();
      else if (centred) {
        centred = false;
        root.classList.remove('is-centred');
      }
      onScroll();
    });
    // content above changing height (images, folds) moves the slot
    if ('ResizeObserver' in window) {
      new ResizeObserver(function () {
        if (docked) place();
      }).observe(document.body);
    }
    check();
  })();

  restore();
})();
